import { IsDefined, IsInt, IsISO8601, IsNumber, IsOptional, IsString, Matches } from 'class-validator';
import { Exclude } from 'class-transformer';

export class BillingSubscriptionPriceCreateDto {
  @Exclude()
  id?: number;

  @IsDefined()
  @IsInt()
  currencyId: number;

  @IsDefined()
  @IsInt()
  vatRateId: number;

  @IsDefined()
  @IsNumber({maxDecimalPlaces: 2})
  price: number;

  @IsDefined()
  @IsString()
  @IsISO8601()
  @Matches(/^\d{4}-\d{2}-\d{2}$/)
  effectiveFrom: string;

  @IsOptional()
  @IsInt()
  trialDays: number;
}